// Assets
import { ArrowPaginateIcon } from 'components/Icons/Icons';

// Components
import { Box, Button, Flex, Text } from '@chakra-ui/react';

const Main = ({ meta, currentPage, onPageChange, isLoadingPage, setIsLoadingPage }) => {
  const totalPages = Math.ceil(meta.total / meta.limit);
  const styleText = {
    fontSize: '16px !important',
    fontStyle: 'italic',
    padding: '12px 15px 12px 12px'
  };

  const getPageArray = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
        pages.push(i);
      } else if (pages[pages.length - 1] !== '...') {
        pages.push('...');
      }
    }
    return pages;
  };

  const handlePageClick = (page) => {
    if (page !== '...') {
      const newOffset = (page - 1) * meta.limit;
      onPageChange(newOffset);
      setIsLoadingPage(true);
    }
  };

  return (
    <Flex 
      justifyContent="center" 
      mt="32px" 
      gap="12px" 
      flexWrap="wrap" 
      pointerEvents={ isLoadingPage ? 'none' : 'unset' }
      opacity={ isLoadingPage ? '0.8' : '1' }
      style={styleText}
      >
      <Button
        onClick={() => handlePageClick(currentPage - 1)}
        isDisabled={currentPage === 1}
        variant="solid-lg"
        borderColor={currentPage === 1 ? '#262D47' : '#2ABDFD'}
        w="64px"
        borderRadius="full"
      >
        <ArrowPaginateIcon 
          fontSize="24px" 
          style={{ transform: 'rotate(180deg)', opacity: currentPage === 1 ? 0.3 : 1 }}
          />
      </Button>
      {getPageArray().map((page, index) => (
        <Button
          key={index}
          onClick={() => handlePageClick(page)}
          variant={page === currentPage ? 'button-lg' : 'solid-lg'}
          borderRadius="full"
          w="64px"
          borderColor={page === currentPage ? 'initial' : '#262D47'}
          pointerEvents={ page === '...' ? 'none' : 'unset' }
          style={ page === '...' ? {} : styleText}
          _hover={{ bg: page === currentPage ? '#2ABDFD' : 'whiteAlpha.200' }}
        >
          {page}
        </Button>
      ))}
      <Button
        onClick={() => handlePageClick(currentPage + 1)}
        isDisabled={currentPage === totalPages}
        variant="solid-lg"
        borderColor={currentPage === totalPages ? '#262D47' : '#2ABDFD'}
        w="64px"
        borderRadius="full"
        style={styleText}
      >
        <ArrowPaginateIcon 
          fontSize="24px" 
          style={{ opacity: currentPage === totalPages ? 0.3 : 1 }}
          />
      </Button>
    </Flex>
  );
};

export default Main;